import { makeStyles } from '@material-ui/core';

export const useHeaderStyles = makeStyles((theme) => ({
  header: (props) => ({
    backgroundColor: props.backgroundColor
      ? props.backgroundColor
      : theme.palette.background.default,
  }),
  headerElements: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    [theme.breakpoints.up('lg')]: {
      padding: '0.5rem 5rem',
    },
  },
}));
